import { ApiHelper, ErrorResponseInterceptor, ResponseInterceptor } from '@/js-api-common'
import { errorToMessage } from './errors/error-messages'
import log from './log'
import { AuthApi } from './user-apis/AuthApi'
import { CLApiPageApi } from './user-apis/CLApiPageApi'
import { CLCodeApi } from './user-apis/CLCodeApi'
import { CLCodeTypeApi } from './user-apis/CLCodeTypeApi'
import { CLEtcApi } from './user-apis/CLEtcApi'
import { CLJobApi } from './user-apis/CLJobApi'
import { CLNavApi } from './user-apis/CLNavApi'
import { CLPrivApi } from './user-apis/CLPrivApi'
import { CLRoleApi } from './user-apis/CLRoleApi'
import { CLRoleUserApi } from './user-apis/CLRoleUserApi'
import { CLSystemLogApi } from './user-apis/CLSystemLogApi'
import { ColmMppnDefnApi } from './user-apis/ColmMppnDefnApi'
import { MetaApi } from './user-apis/MetaApi'
import { MetaGlossaryApi } from './user-apis/MetaGlossaryApi'
import { PdsApi } from './user-apis/PdsApi'
import { ProfileApi } from './user-apis/ProfileApi'
import { TeamApi } from './user-apis/TeamApi'
import { UserApi } from './user-apis/UserApi'
import { UserManageApi } from './user-apis/UserManageApi'
import { CWTaskManageApi } from './user-apis/CWTaskManageApi'
import { CWLabelingApi } from './user-apis/CWLabelingApi'
import { CWCommonApi } from './user-apis/CWCommonApi'
import { CWMainApi } from './user-apis/CWMainApi'
import { CWMgntViewApi } from './user-apis/CWMgntViewApi'
import { CWExtractApi } from './user-apis/CWExtractApi'
import { CWInspectionApi } from './user-apis/CWInspectionApi'
import { CWLabelingCheckApi } from './user-apis/CWLabelingCheckApi'
import { CWStatisticsManageApi } from './user-apis/CWStatisticsManageApi'
import { CWWorkerFactApi } from './user-apis/CWWorkerFactApi'
import { CWPaymentManageApi } from './user-apis/CWPaymentManageApi'
import { CWIntegrationApi } from './user-apis/CWIntegrationApi '
import { CWAdminInteUpdateApi } from './user-apis/CWAdminInteUpdateApi'
import { CWProfessorApi } from './user-apis/CWProfessorApi'
export class UserMainApi {
  helper: ApiHelper
  // begin clover framework apis
  clCode: CLCodeApi
  clCodeType: CLCodeTypeApi
  clJob: CLJobApi
  clSystemLog: CLSystemLogApi
  clEtc: CLEtcApi
  clNav: CLNavApi
  clPriv: CLPrivApi
  clRole: CLRoleApi
  clRoleUser: CLRoleUserApi
  clPageApi: CLApiPageApi

  // end clover framework apis
  auth: AuthApi
  meta: MetaApi
  pds: PdsApi
  user: UserApi
  userManage: UserManageApi
  team: TeamApi
  glossary: MetaGlossaryApi
  profile: ProfileApi
  mppnDefn: ColmMppnDefnApi

  // crowd work platform apis
  taskManage: CWTaskManageApi
  labeling: CWLabelingApi
  labelingCheck: CWLabelingCheckApi
  common: CWCommonApi
  main: CWMainApi
  extract: CWExtractApi
  mgntView: CWMgntViewApi
  inspection: CWInspectionApi
  statisticsManage: CWStatisticsManageApi
  workerFact: CWWorkerFactApi
  paymentManage: CWPaymentManageApi
  integration: CWIntegrationApi
  adminInteg: CWAdminInteUpdateApi
  professor: CWProfessorApi

  constructor(
    public apiBaseURL: string,
    createApiHeader: () => Record<string, string>,
    responseInterceptor: ResponseInterceptor,
    errorResponseInterceptor: ErrorResponseInterceptor,
    debug = false,
  ) {
    log.debug('create Api for ', apiBaseURL)

    // create helper
    const helper = new ApiHelper(
      apiBaseURL,
      createApiHeader,
      responseInterceptor,
      errorResponseInterceptor,
      errorToMessage,
      debug,
    )

    this.helper = helper

    // begin clover framework apis
    this.clCode = new CLCodeApi(helper)
    this.clCodeType = new CLCodeTypeApi(helper)
    this.clJob = new CLJobApi(helper)
    this.clSystemLog = new CLSystemLogApi(helper)
    this.clEtc = new CLEtcApi(helper)
    this.clNav = new CLNavApi(helper)
    this.clPriv = new CLPrivApi(helper)
    this.clRole = new CLRoleApi(helper)
    this.clRoleUser = new CLRoleUserApi(helper)
    this.clPageApi = new CLApiPageApi(helper)
    // end clover framework apis
    this.auth = new AuthApi(helper)
    this.meta = new MetaApi(helper)
    this.pds = new PdsApi(helper)
    this.user = new UserApi(helper)
    this.userManage = new UserManageApi(helper)
    this.team = new TeamApi(helper)
    this.glossary = new MetaGlossaryApi(helper)
    this.profile = new ProfileApi(helper)
    this.mppnDefn = new ColmMppnDefnApi(helper)
    // crowd work platform apis
    this.taskManage = new CWTaskManageApi(helper)
    this.labeling = new CWLabelingApi(helper)
    this.labelingCheck = new CWLabelingCheckApi(helper)
    this.common = new CWCommonApi(helper)
    this.main = new CWMainApi(helper)
    this.mgntView = new CWMgntViewApi(helper)
    this.extract = new CWExtractApi(helper)
    this.inspection = new CWInspectionApi(helper)
    this.statisticsManage = new CWStatisticsManageApi(helper)
    this.workerFact = new CWWorkerFactApi(helper)
    this.paymentManage = new CWPaymentManageApi(helper)
    this.integration = new CWIntegrationApi(helper)
    this.adminInteg = new CWAdminInteUpdateApi(helper)
    this.professor = new CWProfessorApi(helper)
  }
}
